export const ADD_DIRECT_MESSAGE = 'ADD_DIRECT_MESSAGE';
export const DELETE_DIRECT_MESSAGE = 'DELETE_DIRECT_MESSAGE';

// update chat direct messages read status
export const UPDATE_CHAT_DIRECT_MESSAGES_READ_STATUS =
  'UpdateChatDirectMessagesReadStatus';
export const UPDATE_CHAT_DIRECT_MESSAGES_READ_STATUS_SUCCESS =
  'UpdateChatDirectMessagesReadStatusSuccess';
export const UPDATE_CHAT_DIRECT_MESSAGES_READ_STATUS_ERROR =
  'UpdateChatDirectMessagesReadStatusError';

// Clear initial messages
export const CLEAR_CHAT_DIRECT_MESSAGES =
  'CLEAR_CHAT_DIRECT_MESSAGES';

// New message added to trigger refetch on chatthreads.
export const NEW_INCOMING_MESSAGE_ADDED =
  'NEW_INCOMING_MESSAGE_ADDED';
